import * as table from './src/table'

export const ui = {
  ...table,
}
